import { render, staticRenderFns } from "./LandingFeatures.vue?vue&type=template&id=723b49d4"
import script from "./LandingFeatures.vue?vue&type=script&lang=js"
export * from "./LandingFeatures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LandingList: require('/src/components/landing/LandingList.vue').default})
